import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import Label from '../../../components/Label/Label.js';
import ErrorText from '../../../components/FormField/ErrorText.js';
import HelperText from '../../../components/FormField/HelperText.js';
import '../../../utils/getSubDataTestId/index.js';
import styles from './InputField.js';
import getSubDataTestId from '../../../utils/getSubDataTestId/getSubDataTestId.js';

const FormFieldWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    inputId,
    labelId,
    'data-testid': dataTestId,
    label,
    helperText,
    errorText,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: classNames(styles.formFieldWrapper, className),
    ref: ref
  }, rest), label && /*#__PURE__*/React__default.createElement(Label, {
    id: labelId,
    className: styles.label,
    htmlFor: inputId,
    "data-testid": getSubDataTestId(dataTestId, 'label')
  }, label), children, errorText && /*#__PURE__*/React__default.createElement(ErrorText, {
    "data-testid": getSubDataTestId(dataTestId, 'error-text'),
    className: styles.caption
  }, errorText), helperText && /*#__PURE__*/React__default.createElement(HelperText, {
    "data-testid": getSubDataTestId(dataTestId, 'helper-text'),
    className: styles.caption
  }, helperText));
});

export { FormFieldWrapper as default };
